import { render, staticRenderFns } from "./DatesList.vue?vue&type=template&id=65fd3db6&"
import script from "./DatesList.vue?vue&type=script&lang=js&"
export * from "./DatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports